import _asyncToGenerator from "/vercel/path0/node_modules/next/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _regeneratorRuntime from "/vercel/path0/node_modules/next/node_modules/@babel/runtime/regenerator";

/* eslint-disable @typescript-eslint/no-shadow */
import * as definitions from '../../definitions/booking';
import { createAction } from '../../interfaces';
import bookingService from '../../services/booking';
import { getErrorMessageFromErrorResponse, handleErrorResponse } from '../../utils/error';
import { redirectActionCreators as redirectActions } from './redirect';
export var bookingActionCreators = {
  getUserBookingsRequest: function getUserBookingsRequest(userId) {
    return createAction(definitions.GET_USER_BOOKINGS_REQUEST, userId);
  },
  getUserBookingsSuccess: function getUserBookingsSuccess(bookings) {
    return createAction(definitions.GET_USER_BOOKINGS_SUCCESS, bookings);
  },
  getUserBookingsFail: function getUserBookingsFail(error) {
    return createAction(definitions.GET_USER_BOOKINGS_FAIL, error);
  },
  getUserSessionBookingsRequest: function getUserSessionBookingsRequest() {
    return createAction(definitions.GET_USER_SESSION_BOOKINGS_REQUEST);
  },
  getUserSessionBookingsSuccess: function getUserSessionBookingsSuccess(bookings) {
    return createAction(definitions.GET_USER_SESSION_BOOKINGS_SUCCESS, bookings);
  },
  getUserSessionBookingsFail: function getUserSessionBookingsFail(error) {
    return createAction(definitions.GET_USER_SESSION_BOOKINGS_FAIL, error);
  },
  getBookingByIdRequest: function getBookingByIdRequest(id) {
    return createAction(definitions.GET_BOOKING_BY_ID_REQUEST, id);
  },
  getBookingByIdSuccess: function getBookingByIdSuccess(booking) {
    return createAction(definitions.GET_BOOKING_BY_ID_SUCCESS, booking);
  },
  getBookingByIdFail: function getBookingByIdFail(error) {
    return createAction(definitions.GET_BOOKING_BY_ID_FAIL, error);
  },
  cancelBookingRequest: function cancelBookingRequest(id) {
    return createAction(definitions.CANCEL_BOOKING_REQUEST, id);
  },
  cancelBookingSuccess: function cancelBookingSuccess(id) {
    return createAction(definitions.CANCEL_BOOKING_SUCCESS, id);
  },
  cancelBookingFail: function cancelBookingFail(error) {
    return createAction(definitions.CANCEL_BOOKING_FAIL, error);
  },
  createBookingRequest: function createBookingRequest() {
    return createAction(definitions.CREATE_BOOKING_REQUEST);
  },
  createBookingSuccess: function createBookingSuccess(booking) {
    return createAction(definitions.CREATE_BOOKING_SUCCESS, booking);
  },
  createBookingFail: function createBookingFail(error) {
    return createAction(definitions.CREATE_BOOKING_FAIL, error);
  },
  clearBookingErrors: function clearBookingErrors() {
    return createAction(definitions.CLEAR_BOOKING_ERRORS);
  },
  setBookingInfo: function setBookingInfo(info) {
    return createAction(definitions.SET_BOOKING_INFO, info);
  },
  clearBookingInfo: function clearBookingInfo() {
    return createAction(definitions.CLEAR_BOOKING_INFO);
  },
  clearBookingData: function clearBookingData() {
    return createAction(definitions.CLEAR_BOOKING_DATA);
  }
};
export var clearBookingData = function clearBookingData() {
  return function (dispatch) {
    var clearBookingDataAction = bookingActionCreators.clearBookingData;
    dispatch(clearBookingDataAction());
  };
};
export var getUserBookings = function getUserBookings(userId) {
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(dispatch) {
      var getUserBookingsRequest, getUserBookingsSuccess, getUserBookingsFail;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              getUserBookingsRequest = bookingActionCreators.getUserBookingsRequest, getUserBookingsSuccess = bookingActionCreators.getUserBookingsSuccess, getUserBookingsFail = bookingActionCreators.getUserBookingsFail;
              dispatch(getUserBookingsRequest(userId));
              return _context.abrupt("return", bookingService.getUserBookings(userId).then(function (bookings) {
                dispatch(getUserBookingsSuccess(bookings));
              }, function (error) {
                var message = getErrorMessageFromErrorResponse(error);
                dispatch(getUserBookingsFail(message));
                handleErrorResponse(error, dispatch);
              }));

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
};
export var getUserSessionBookings = function getUserSessionBookings(sessionId) {
  return /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(dispatch) {
      var getUserSessionBookingsRequest, getUserSessionBookingsSuccess, getUserSessionBookingsFail;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              getUserSessionBookingsRequest = bookingActionCreators.getUserSessionBookingsRequest, getUserSessionBookingsSuccess = bookingActionCreators.getUserSessionBookingsSuccess, getUserSessionBookingsFail = bookingActionCreators.getUserSessionBookingsFail;
              dispatch(getUserSessionBookingsRequest());
              return _context2.abrupt("return", bookingService.getCurrentUserSessionBookings(sessionId).then(function (bookings) {
                dispatch(getUserSessionBookingsSuccess(bookings));
              }, function (error) {
                var message = getErrorMessageFromErrorResponse(error);
                dispatch(getUserSessionBookingsFail(message));
                handleErrorResponse(error, dispatch);
              }));

            case 3:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function (_x2) {
      return _ref2.apply(this, arguments);
    };
  }();
};
export var getBookingById = function getBookingById(id) {
  return /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(dispatch) {
      var getBookingByIdRequest, getBookingByIdSuccess, getBookingByIdFail;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              getBookingByIdRequest = bookingActionCreators.getBookingByIdRequest, getBookingByIdSuccess = bookingActionCreators.getBookingByIdSuccess, getBookingByIdFail = bookingActionCreators.getBookingByIdFail;
              dispatch(getBookingByIdRequest(id));
              return _context3.abrupt("return", bookingService.getBookingById(id).then(function (booking) {
                dispatch(getBookingByIdSuccess(booking));
              }, function (error) {
                var message = getErrorMessageFromErrorResponse(error);
                dispatch(getBookingByIdFail(message));
                handleErrorResponse(error, dispatch);
              }));

            case 3:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function (_x3) {
      return _ref3.apply(this, arguments);
    };
  }();
};
export var cancelBooking = function cancelBooking(serviceId, sessionId, bookingId) {
  return /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(dispatch) {
      var cancelBookingRequest, cancelBookingSuccess, cancelBookingFail;
      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              cancelBookingRequest = bookingActionCreators.cancelBookingRequest, cancelBookingSuccess = bookingActionCreators.cancelBookingSuccess, cancelBookingFail = bookingActionCreators.cancelBookingFail;
              dispatch(cancelBookingRequest(bookingId));
              return _context4.abrupt("return", bookingService.cancelBooking(serviceId, sessionId, bookingId).then(function (booking) {
                dispatch(cancelBookingSuccess(booking));
              }, function (error) {
                var message = getErrorMessageFromErrorResponse(error);
                dispatch(cancelBookingFail(message));
                handleErrorResponse(error, dispatch);
              }));

            case 3:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));

    return function (_x4) {
      return _ref4.apply(this, arguments);
    };
  }();
};
export var createBooking = function createBooking(dto) {
  return /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(dispatch) {
      var createBookingRequest, createBookingSuccess, createBookingFail;
      return _regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              createBookingRequest = bookingActionCreators.createBookingRequest, createBookingSuccess = bookingActionCreators.createBookingSuccess, createBookingFail = bookingActionCreators.createBookingFail;
              dispatch(createBookingRequest());
              return _context5.abrupt("return", bookingService.createBooking(dto).then(function (booking) {
                dispatch(createBookingSuccess(booking));
                var query = new URLSearchParams(window.location.search);
                var redirect = query.get('redirect');
                var redirectTo = redirect ? redirect : "/bookings/".concat(booking.id);
                dispatch(redirectActions.redirectTo(redirectTo));
                return booking;
              }, function (error) {
                var message = getErrorMessageFromErrorResponse(error);
                dispatch(createBookingFail(message));
                handleErrorResponse(error, dispatch);
              }));

            case 3:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    }));

    return function (_x5) {
      return _ref5.apply(this, arguments);
    };
  }();
};
export var clearBookingErrors = function clearBookingErrors() {
  return function (dispatch) {
    var clearBookingErrorsAction = bookingActionCreators.clearBookingErrors;
    dispatch(clearBookingErrorsAction());
  };
};
export var setBookingInfo = function setBookingInfo(info) {
  return function (dispatch) {
    var setBookingInfoAction = bookingActionCreators.setBookingInfo;
    dispatch(setBookingInfoAction(info));
  };
};
export var clearBookingInfo = function clearBookingInfo() {
  return function (dispatch) {
    var clearBookingInfoAction = bookingActionCreators.clearBookingInfo;
    dispatch(clearBookingInfoAction());
  };
};